import { render, staticRenderFns } from "./PanelSelectUser.vue?vue&type=template&id=0b1b6c68&scoped=true&"
import script from "./PanelSelectUser.vue?vue&type=script&lang=ts&"
export * from "./PanelSelectUser.vue?vue&type=script&lang=ts&"
import style0 from "./PanelSelectUser.vue?vue&type=style&index=0&id=0b1b6c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b6c68",
  null
  
)

export default component.exports